import Box from "@memorang/ui/components/Box";
import Loader from "@memorang/ui/components/Loader";
/* -----------------Types--------------- */
import type { Stat } from "@memorang/ui/components/RowStats";
/* -----------------Child components--------------- */
import ProfileHeader from "./ProfileHeader";
import ProfileStatsView from "./ProfileStatsView";

type Section = {
	title: string;
	data: {
		title: string;
		subtitle?: string;
		icon?: string;
		type?: string;
		rightText?: string;
	}[];
};

type Props = {
	headerStats?: Stat[];
	statsTabData?: Section[];
};

const ProfileView = ({ headerStats, statsTabData }: Props) => {
	if (!statsTabData?.length) {
		return (
			<Box
				flexGrow={1}
				height={"100%"}
				padding={24}
				style={{
					minHeight: 200,
				}}
			>
				<Loader />
			</Box>
		);
	}

	return (
		<Box gap={16}>
			<ProfileHeader stats={headerStats!} />
			<ProfileStatsView sections={statsTabData} />
		</Box>
	);
};

export default ProfileView;
